<small class="debug"> {{me}} </small>
<div fxLayout="row" fxLayoutAlign="center center">
    <div class="overview-log-table">
        <div fxLayout="row" fxLayoutAlign="center center">
            <fa-icon size="8x" style="position: relative; left: 10px; opacity: 0.7" [icon]="faCcPaypal"></fa-icon>
        </div>
        <br/>
        <mat-label style="font-size: 2em">{{'general.thankYouOrder' | transloco}}</mat-label>
        <div fxLayout="row" fxLayoutAlign="center center">
            <mat-icon style="color: green; font-size: 5em; position: relative; left: -21px; top: 41px">check_circle_outline</mat-icon>
        </div>
                <div fxLayout="row" fxLayoutAlign="center center">
                    <mat-spinner></mat-spinner>
                </div>
        <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 200px">
            <button mat-flat-button (click)="onGoOrders()">{{'general.continue' | transloco}}
                <mat-icon>fast_forward</mat-icon>
            </button>
        </div>
        <br/>
    </div>
</div>
